import icon from 'vue-svgicon';

icon.register({
    'light/pin': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M9.914 14.085L.5 23.499M21.414 8.585a.707.707 0 0 0 1 0l.793-.793a1 1 0 0 0 0-1.414L17.621.792a1 1 0 0 0-1.414 0l-.793.793a.707.707 0 0 0 0 1 .707.707 0 0 1 0 1l-4.207 4.207a1 1 0 0 1-.707.293H7.328a1 1 0 0 0-.707.293l-.5.5a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0l.5-.5a1 1 0 0 0 .293-.707V13.5a1 1 0 0 1 .293-.707l4.207-4.207a.707.707 0 0 1 1-.001z"/>`,
    },
});
